import * as React from 'react';
import { Check } from 'lucide-react';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  label?: React.ReactNode;
  description?: React.ReactNode;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className = '', checked = false, onCheckedChange, label, description, disabled, id, ...props }, ref) => {
    const generatedId = React.useId();
    const inputId = id || generatedId;

    return (
      <label
        htmlFor={inputId}
        className={`shadcn-checkbox-wrap ${disabled ? 'disabled' : ''} ${className}`.trim()}
      >
        <input
          type="checkbox"
          id={inputId}
          ref={ref}
          checked={checked}
          disabled={disabled}
          onChange={(e) => onCheckedChange?.(e.target.checked)}
          className="shadcn-sr-only"
          {...props}
        />
        <div className={`shadcn-checkbox ${checked ? 'checked' : ''}`} aria-hidden="true">
          {checked && <Check size={11} strokeWidth={3} className="shadcn-checkbox-check" />}
        </div>
        {(label || description) && (
          <div className="shadcn-checkbox-text">
            {label && <span className="shadcn-checkbox-label">{label}</span>}
            {description && <span className="shadcn-checkbox-desc">{description}</span>}
          </div>
        )}
      </label>
    );
  }
);
Checkbox.displayName = 'Checkbox';
